import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

function GotoLocations({ setRoute }) {
  const { popDialog } = useDialog()

  useEffect(() => {
    if (setRoute) {
      setRoute('/location-selection')
    }
    popDialog()
  }, [])

  return null
}

GotoLocations.propTypes = {
  setRoute: PropTypes.func,
}

export default GotoLocations
